import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as Actions from '../../../store/actions';
import _ from 'lodash';

export class CartInputDiscountCode extends Component {

    constructor(props) {
        super(props)
    
        this.state = {
            discountCode: props.discountCode
        }
    }

    componentDidUpdate(prevProps) {
        const { discountCode, ItemSelected, UpdatePromotion } = this.props;
        if (!_.isEqual(prevProps.discountCode, discountCode)) {
            this.setState({ discountCode: discountCode });
            if (discountCode == "") UpdatePromotion(ItemSelected, discountCode);
        }

    }

    handleKeyPressInput = e => {
        e.persist();
        this.setState({ discountCode: e.target.value });
    }

    render() {

        const { wording, UpdatePromotion, ItemSelected, isLoading, promotion } = this.props;
        const { discountCode } = this.state;
        const error = (promotion.find(pro => pro.promotionid < 0) || null)?.errorMassege;

        return (
            <tr className='cart-discount-code'>
                <th style={{ color: '#fff' }}>
                    {wording.cartPage.cartTotal.discountCode}
                </th>
                <td style={{ color: '#fff', textAlign: 'right', paddingBottom: '0px' }}>
                    <div className="flex horizontal-end vertical-stretch mb-10">
                        <input type="text" ref="inputDiscountCode" className="text-white mb-0 w-50 h-auto" value={discountCode} onChange={this.handleKeyPressInput} />
                        <button
                            className='btn btn-md btn-color'
                            onClick={() => UpdatePromotion(ItemSelected, this.state.discountCode)}>
                            {
                                isLoading
                                    ? "Loading..."
                                    : wording.cartPage.cartTotal.confirm
                            }
                        </button>
                    </div>
                    { error && <span className='error ml-10' style={{ color: "#db2828" }}>* {error}</span> }
                </td>
            </tr>
        )
    }
}

const mapStateToProps = ({ language, cart }) => ({
	wording: language.wording,
    discountCode: cart.discountCode,
    isLoading: cart.isLoading
});

const mapDispatchToProps = dispatch => {
	return bindActionCreators(
		{
			UpdatePromotion: Actions.UpdatePromotion,
		},
		dispatch
	)
};

export default connect(mapStateToProps, mapDispatchToProps)(CartInputDiscountCode);
